import React, { Component } from 'react'

import axios from 'axios'

import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'

import EmailField from '../fields/email-field'

import requestResetPassword from '../../../queries/3dmssapi/request-reset-password'

const ResetPasswordFormModal = class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: undefined,
      email_touched: false,
      loading: false,
      notificationShow: false,
      sent: false,
      showErrorNotification: false,
      errors: false
    }

    this.cancelToken = axios.CancelToken.source()
  }

  componentWillUnmount() {
    try {
      this.cancelToken.cancel()
    } catch(error) {
      console.log(error)
    }
  }

  showNotification = () => {
    this.setState({notificationShow: true})
  }

  hideNotification = () => {
    this.setState({notificationShow: false})
  }

  showErrorNotification = () => {
    this.setState({showErrorNotification: true})
  }

  hideErrorNotification = () => {
    this.setState({showErrorNotification: false})
  }

  postResetPassword = (e) => {
    e.preventDefault()
    this.setState({loading: true})

    requestResetPassword(this.cancelToken, this.state.email)
      .then(response => {
        console.log(response);
        if (response.status === 200 && !response.data.errors) {
            this.setState({notificationShow: true, loading: false, sent: true, showErrorNotification: false});
        } else if (response.status === 200 && response.data.errors) {
            this.setState({errors: false, loading: false, showErrorNotification: true});
        }
      })
      .catch(error => {
        if(axios.isCancel(error)) {
          console.log(`Request canceled: ${error}`);
          this.setState({errors: true, loading: false, showErrorNotification: true});
        } else {
          console.log(error);
          this.setState({errors: true, loading: false, showErrorNotification: true});
        }
      })
    // e.preventDefault()
    // this.setState({loading: true})

    // let data = {"email": this.state.email, "password": this.state.password}

    // if(this.props.infoat) {
    //   data["infoat"] = this.props.infoat === "true"
    // }

    // console.log(data)
    // axios({
    //   // url: 'http://127.0.0.1:8888/post-specific-form',
    //   url: 'https://pymail.bscs.org/post-reset-password-form',
    //   method: 'post',
    //   data: data,
    //   cancelToken: this.cancelToken.token
    // })
    // .then(response => {
    //   console.log(response);
    //   if(response.status === 200) {
    //       this.setState({notificationShow: true, loading: false, sent: true});
    //   }
    // })
    // .catch(error => {
    //   if(axios.isCancel(error)) {
    //     console.log(`Request canceled: ${error}`);
    //     this.setState({errors: true, showErrorNotification: true});
    //   } else {
    //     console.log(error);
    //     this.setState({errors: true, showErrorNotification: true});
    //   }
    // })
  }

  render() {
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="reset-password-form-modal"
        centered
      >
      <Modal.Header closeButton>
        <Modal.Title id="reset-password-form-modal">
          {/* Contact: {this.props.sendto} */}
          Reset Password
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <EmailField
              id="rp-email-input"
              invalid_message="Please provide a valid email address."
              label="Email"
              setField={(value) => this.setState({email: value})}
              xs={12}
            />
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Container>
          <Row>
            <Col xs={12}>
              <Alert show={this.state.notificationShow} onClose={this.hideNotification} dismissible variant="success">
                <p>An email has been sent to {this.state.email} with further instructions for resetting your password.</p>
              </Alert>
              <Alert show={this.state.showErrorNotification} onClose={this.hideErrorNotification} dismissible variant="danger">
                We are having problems with our servers right now.  Please try again later.  Sorry for the inconvenience.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-end">
                { !this.state.errors && !this.state.loading && !this.state.sent && !this.state.email &&
                  <Button variant="outline-primary" disabled>Send Reset Password Email</Button>
                }
                { !this.state.errors && !this.state.loading && !this.state.sent && this.state.email &&
                  <Button variant="outline-primary" onClick={this.postResetPassword}>Send Reset Password Email</Button>
                }
                { !this.state.errors && this.state.loading &&
                  <Button variant="outline-success" disabled>
                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    Sending...
                  </Button>
                }
                { !this.state.errors && !this.state.loading && this.state.sent &&
                  <Button variant="outline-success" disabled>Sent</Button>
                }
                { this.state.errors &&
                  <Button variant="outline-danger" disabled>Error</Button>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Footer>
    </Modal>
    )
  }
}

export default ResetPasswordFormModal